export const ServiceProtocolType = {
  SERVICE_40H: 10,
  SERVICE_250H: 20,
  SERVICE_500H: 30,
  SERVICE_1000H_YEARLY: 40,
  WEEKLY_SERVICE: 50,
  OTHER_SERVICE: 60,
}
